import { RestClient } from './RestClient'

export class BackupCodesClient extends RestClient {
  /**
   * BackupCodesClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    this.baseUrl = '/users/me/2fa/codes'
  }

  /**
   * Get a list of the backup codes of the current user
   *
   * @returns {AxiosPromise}
   */
  list (authorizationPassword) {
    return this.call('post', this.baseUrl, {
      'confirmation_password': authorizationPassword
    })
  }

  /**
   * Refresh the backup codes of the current user
   *
   * @returns {AxiosPromise}
   */
  refresh (authorizationPassword) {
    return this.call('post', `${this.baseUrl}/refresh`, {
      'confirmation_password': authorizationPassword
    })
  }
}
